import { FC, MouseEvent, useCallback } from 'react'
import { useTimeout } from '../../helpers/hooks/useTimeout'

const ForceReloadToast: FC = () => {
  const refresh = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    location.reload()
  }, [])

  const remainingSeconds = useTimeout(() => {
    location.reload()
  }, 10)

  const remainingMessage =
    remainingSeconds > 1
      ? `in ${remainingSeconds} seconds`
      : remainingSeconds === 1
      ? 'in one second'
      : 'now'

  return (
    <div data-testid="message-error">
      Inconsistent data was received from the server. It may be because the
      server was restarted, or because the connection was closed. The page will
      be refreshed {remainingMessage}…{' '}
      <a href="#" onClick={refresh} data-testid="reload-now">
        Refresh now
      </a>
      .
    </div>
  )
}

export const getForceReloadToastInstance = () => <ForceReloadToast />

export default ForceReloadToast
